import loginVideo from "../../../assets/auth_video/login.mp4";

export const LOGIN_VIDEO = loginVideo;
